<template>
    <div class="md-layout-item md-medium-size-20 sem-summary-dateblock mt-15px">
        <ul class="list-inline">
            <li class="list-inline-item">
                <label class="card-header">{{ label }}</label>
            </li>
            <li class="list-inline-item">
                <DatePicker v-model="dateValue" format="MM/DD" valueType="format" @input="updateDate"></DatePicker>
            </li>
            <li class="list-inline-item">
                <md-field>
                    <md-select v-model="selectedRange" :key="selectedRange">
                        <md-option v-for="range in dateRanges" :key="range.value" :value="String(range.value)">
                            {{ range.label }}
                        </md-option>
                        <md-option value="custom">Custom Date</md-option>
                    </md-select>
                </md-field>
            </li>
            <li class="list-inline-item" v-if="selectedRange === 'custom'">
                <md-field>
                    <md-input type="number" min="1" v-model.number="customDays" placeholder="Enter days"
                        @input="handleCustomDaysInput"></md-input>
                </md-field>
            </li>
        </ul>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';

export default {
    components: {
        DatePicker
    },
    props: {
        label: {
            type: String,
            required: true
        },
        date: {
            type: String,
            default: ''
        },
        range: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            dateValue: this.date,
            selectedRange: null,
            customDays: null,
            dateRanges: [
                { label: 'Last 7 days', value: 7 },
                { label: 'Last 30 days', value: 30 },
                { label: 'Last 60 days', value: 60 },
                { label: 'Last 90 days', value: 90 },
            ]
        };
    },
    created() {
        this.initializeRange(this.range);
    },
    methods: {
        updateDate(newDate) {
            this.$emit('update:date', newDate);
        },
        handleCustomDaysInput() {
            const days = this.customDays;

            if (
                this.selectedRange === 'custom' &&
                days !== null &&
                days !== '' &&
                !isNaN(days) &&
                Number(days) > 0
            ) {
                this.$emit('update:range', parseInt(days));
            }
        },

        validate() {
            return true;
        },
        initializeRange(val) {
            const knownRanges = [7, 30, 60, 90];
            if (typeof val === 'number' && knownRanges.includes(val)) {
                this.selectedRange = String(val);
                this.customDays = null;
            } else if (typeof val === 'number') {
                this.selectedRange = 'custom';
                this.$nextTick(() => {
                    this.customDays = val;
                    this.$emit('update:range', val);
                });
            } else {
                this.selectedRange = null;
                this.customDays = null;
            }
        }

    },
    watch: {
        date(newVal) {
            this.dateValue = newVal;
            if (!newVal) {
                this.selectedRange = null;
                this.customDays = null;
            }
        },
        range(newVal) {
            this.initializeRange(newVal);
        },
        selectedRange(newVal) {
            if (newVal && newVal !== 'custom') {
                this.$emit('update:range', parseInt(newVal));
                this.customDays = null;
            } else if (newVal !== 'custom') {
                this.$emit('update:range', null);
            }
        }
    }
};

</script>


// WEBPACK FOOTER //
// src/components/SemesterDateBlock.vue